import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import React from 'react';

interface DeleteBlacklistDialogProps {
  open: boolean;
  onClose: () => void;
  businessName: string;
  deleteReason: string;
  onReasonChange: (reason: string) => void;
  onDelete: () => void;
  loading: boolean;
  reason: string;
}

const DeleteBlacklistDialog: React.FC<DeleteBlacklistDialogProps> = ({
  open,
  onClose,
  businessName,
  deleteReason,
  onReasonChange,
  onDelete,
  loading,
  reason,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      maxWidth="lg"
    >
      <DialogTitle
        id="form-dialog-title"
        sx={{ fontSize: '1.1rem', fontWeight: 600 }}
      >
        Eliminar empresa de la blacklist
      </DialogTitle>
      <DialogContent>
        {loading && (
          <div style={{ minHeight: '70px' }}>
            <CenteredCircularProgress type="dialog" />
          </div>
        )}
        {!loading && (
          <div>
            <Typography variant="body1" sx={{ fontSize: '0.95rem' }}>
              Estás seguro de querer eliminar a {businessName} de la blacklist?
            </Typography>
            <TextField
              autoFocus
              margin="dense"
              id="deleteReason"
              label="Razón para eliminar"
              type="text"
              fullWidth
              value={deleteReason}
              onChange={(e) => onReasonChange(e.target.value)}
              multiline
              rows={4}
              placeholder="Ingresar razón para eliminar..."
            />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={onClose} color="secondary" disabled={loading}>
          Cancelar
        </CustomButton>
        <CustomButton
          onClick={onDelete}
          color="success"
          disabled={loading || !reason}
        >
          Quitar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteBlacklistDialog;
